import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import pb from '@/lib/pb'
import { COLLECTIONS } from '@/types'
import type { TSetting } from '@/types'

const COLLECTION = COLLECTIONS.SETTINGS

export function useSettings() {
  return useQuery({
    queryKey: [COLLECTION],
    queryFn: async () => {
      const records = await pb.collection(COLLECTION).getFullList<TSetting>()
      return records
    },
  })
}

export function useSetting(key: string) {
  const { data: settings, ...rest } = useSettings()
  const setting = settings?.find(s => s.key === key)
  return { setting, ...rest }
}

export function useUpdateSetting() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: Partial<TSetting> }) => {
      return await pb.collection(COLLECTION).update<TSetting>(id, data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COLLECTION] })
    },
  })
}

export function useCreateSetting() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: Partial<TSetting>) => {
      return await pb.collection(COLLECTION).create<TSetting>(data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COLLECTION] })
    },
  })
}
